export const getAccessTokenLocalStorage = () =>
  localStorage.getItem("accessToken");
export const setAccessTokenLocalStorage = (token) =>
  localStorage.setItem("accessToken", token);

export const setUserDataLocalStorage = (userData) =>
  localStorage.setItem("currentUser", JSON.stringify(userData));

export const deleteLocalStorage = () => localStorage.clear();
